module.exports = __webpack_public_path__ + "static/media/rooftype-commercial.f80334c9.png";